/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flag_UnmatchedInputs */

const en_flag_unmatched = /** @type {(inputs: Flag_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not matched`)
};

const de_flag_unmatched = /** @type {(inputs: Flag_UnmatchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht zugeordnet`)
};

/**
* | output |
* | --- |
* | "Not matched" |
*
* @param {Flag_UnmatchedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flag_unmatched = /** @type {((inputs?: Flag_UnmatchedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flag_UnmatchedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_flag_unmatched(inputs)
	return en_flag_unmatched(inputs)
});